import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { uniq } from "ramda";
import { useQuery } from "react-query";
import { getMeasurements } from "@webapi/api";
import { useErrorNotifications } from "@notifications/errorNotifications";
import { isNotEmptyArray } from "utils/validation";
import { cleanAndMapifyMeasurementsWithMetadata } from "utils/measurementsWithMetadata";
import { useMeasuresContext } from "@webapi/contexts/measures";
import { useAuthContext } from "@authentication/context";
var withReich = function withReich(x) {
  return _objectSpread(_objectSpread({}, x), {}, {
    units: uniq(x.units.concat("SE"))
  });
};
export var useMeasurementsWithMetadata = function useMeasurementsWithMetadata(params) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var _useMeasuresContext = useMeasuresContext(),
    lookupParentMeasure = _useMeasuresContext.lookupParentMeasure;
  var _useAuthContext = useAuthContext(),
    getUser = _useAuthContext.getUser;
  var authTicket = getUser().ticket;
  var query = withReich(params);
  var queryFunc = function queryFunc() {
    return getMeasurements(query, authTicket).then(function (response) {
      return cleanAndMapifyMeasurementsWithMetadata(params, lookupParentMeasure, response);
    });
  };
  var _useQuery = useQuery(["measurementsWithMetadata", params, authTicket], queryFunc, {
      enabled: enabled && isNotEmptyArray(query.units) && isNotEmptyArray(query.measureIds),
      initialData: new Map(),
      keepPreviousData: true
    }),
    measurementsWithMetadata = _useQuery.data,
    error = _useQuery.error,
    isError = _useQuery.isError,
    isFetching = _useQuery.isFetching,
    refetchMeasurements = _useQuery.refetch;
  useErrorNotifications(error, ". Lyckades inte hämta mätpunkter.");
  return {
    status: status,
    loading: isFetching,
    error: isError,
    errorMessage: error,
    refetchMeasurements: refetchMeasurements,
    measurementsWithMetadata: measurementsWithMetadata
  };
};